const theme = {
  base: {},
  path: {
    stroke: '#01a09e',
    strokeLinecap: 'butt'
  },
  trail: {
    stroke: '#d6d6d6',
    strokeLinecap: 'butt'
  },
  text: {
    fill: '#01a09e',
    textAlign: 'center',
    fontSize: '16px'
  }
}

export default theme
